import tw from 'twin.macro';

import { STATUS } from '@/routes/dashboard/types';

const getStatusStyle = (statusValue: string) => {
  switch (statusValue) {
    case STATUS.NOT_STARTED:
      return tw`bg-gray-100 text-gray-800 border border-gray-300`;
    case STATUS.OVERDUE:
      return tw`bg-red-100 text-red-800 border border-red-300`;
    case STATUS.INCOMPLETE:
      return tw`bg-orange-100 text-orange-800 border border-orange-300`;
    case STATUS.COMPLETED:
      return tw`bg-green-100 text-green-800 border border-green-300`;
    case STATUS.IN_PROGRESS:
      return tw`bg-amber-100 text-amber-800 border border-amber-300`;
    default:
      return tw`bg-gray-100 text-gray-800 border border-gray-300`;
  }
};

export default getStatusStyle;
